// Universal projection constants. Strategies that need a different convention
// (e.g. a product that bills 31-day months) can declare their own and not
// import these.

export const DAYS_IN_MONTH = 30;

// 2-ADL gating: a US LTC-rider activation rule that almost every product
// follows. ≥ 2 ADLs needed for benefit eligibility; earlyCare clients
// with < 2 ADLs only get credit for half the phase days.
export const POLICY_ACTIVATES_AT_ADL_COUNT = 2;
export const ONE_ADL_DURATION_MULTIPLIER = 0.5;
